// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__bP8+D","spin":"Spinner_spin__lEWOp","sm":"Spinner_sm__oy20Z","md":"Spinner_md__-FCo0","lg":"Spinner_lg__RRDC-"};